"use client"

import { getProjectId, ingestUrl, isTrackingDisabled } from "@/lib/analytics"
import { Analytics } from "@remcostoeten/analytics"

export function AnalyticsClient() {
  return (
    <Analytics
      ingestUrl={ingestUrl}
      projectId={getProjectId()}
      disabled={isTrackingDisabled()}
    />
  )
}
